import React from "react";
import hisJourneyImg from "../../assets/images/webp/other/his-journey-img.webp";
import { JOURNEY_LIST } from "../../utils/other-component";
import Icons from "../common/components/Icons";
import BlueTag from "../common/ui/BlueTag";
import Paragraph from "../common/ui/Paragraph";

const HisJourney = () => {
  return (
    <>
      <div className="px-4 pt-[140px] max-xl:pt-[120px] max-lg:pt-26 max-md:pt-20 max-sm:pt-10">
        <div className="max-w-[1140px] mx-auto  flex items-center gap-[76px] max-xl:gap-14 max-lg:gap-10 max-md:gap-8 max-sm:gap-6 max-lg:flex-wrap-reverse">
          <div className="w-full max-w-[584px]">
            <img
              src={hisJourneyImg}
              alt="journey"
              width={584}
              height={491}
              className="w-full object-contain pointer-events-none"
            />
          </div>
          <div className="w-full max-w-[481px] max-lg:max-w-full">
            <BlueTag>His Journey</BlueTag>
            <h2 className="text-[#001A3D] font-bold ff-jakarta text-[50px] max-xl:text-5xl max-lg:text-4xl max-md:text-3xl max-sm:text-2xl leading-[120%]">
              From Soil to Stage
            </h2>
            {JOURNEY_LIST.map((item, index) => (
              <div
                key={index}
                className={`flex items-center gap-2 ${
                  index === 0 ? "pt-5" : "pt-4"
                }`}
              >
                <p className="check-icon">
                  <Icons icon="CheckIcon" />
                </p>
                <p
                  className={`text-[#001A3D] font-semibold text-sm leading-[19.38px]`}
                >
                  {item}
                </p>
              </div>
            ))}
            <Paragraph className="pt-5">
              Starting from scratch, Deepak faced rejections, failures, and even
              moments where most people give up. But he turned every obstacle
              into a stepping stone, and every doubt into determination.
            </Paragraph>
            <Paragraph className="pt-5">
              Today, he is the founder of Makeway India Group, a growing
              business empire that includes ventures in real estate,
              hospitality, and soulful living projects like.
            </Paragraph>
          </div>
        </div>
      </div>
    </>
  );
};

export default HisJourney;
